module.exports = __webpack_public_path__ + "static/media/MyWashLabLogoImg.148eb02c.jpg";